import { FC, useEffect, useState } from "react";
import styles from './index.module.less';
import { Col, Pagination, Row } from "antd";
import { getFileList } from "../../api";
import { useNavigate } from "react-router-dom";
import { download } from "../../utils/download";
import DownloadIcon from './DownloadIcon';
import { useFavicon } from "react-use";

const Index: FC = (props) => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    const getData = async (pg, pp) => {
        const res = await getFileList(pg, pp);
        if (res.total) {
            setData(res.list);
            setTotal(res.total);
            setLoading(false);
        }

    }

    useEffect(() => {
        getData(1, 20);
    }, []);


    return (
        <div style={{width: props.width}} className={styles.body}>
            <div>
                {
                    loading ?
                    <div className={styles.loading}>加载中...</div>
                    :
                    data.map((item) => {
                        return <ListItem {...item}></ListItem>
                    })
                }
            </div>
            {
                !loading &&
                <div className={styles.footer}>
                    <Row>
                        <Col span={3}>共 {total} 项数据</Col>
                        <Col span={21}>
                            <div className={styles.pagination}>
                                <Pagination
                                    onChange={(page) => {
                                        getData(page, 20)
                                        setPage(page);
                                    }}
                                    current={page}
                                    showQuickJumper={true}
                                    pageSize={20}
                                    total={total}
                                    showSizeChanger={false}>
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </div>
            }
        </div>
    );
}

const ListItem = (props) => {
    const [hover, setHover] = useState(false);
    const startDownload = (url, fileName) => {
        download(url, fileName)
    }
    return (
        <div onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)} key={props.id} onClick={() => startDownload(props.url, props.title)} className={styles.item}>
            <li style={{position: 'relative'}}>
                <span>{props.title}</span>
                <span style={{position: 'absolute', right: '0', fontSize: '12px', color: '#999999', marginRight: '180px', top: '1px'}}><DownloadIcon size={18} color={hover ? '#005BAC' : '#999999'} /></span>
                <span style={{position: 'absolute', right: '0', fontSize: '12px', color: '#999999', marginRight: '8px'}}>{props.time}</span>
            </li>
            {/* <div>{item.title}</div> */}
        </div>
    );
}

export default Index;